import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=42814996&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style0 from "./Book.vue?vue&type=style&index=0&id=42814996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42814996",
  null
  
)

export default component.exports